module.exports = __webpack_public_path__ + "static/media/dice-d6.d2791211.svg";